<template>
  <v-card color="verdeclarito" dark elevation="4">
    <!-- barra del medio con los botones de inicio y titulo-->
    <v-card
      v-if="barraEscritorio"
      color="tiendasimilia"
      width="100%"
      height="64"
      align="center"
    >
      <v-container fluid fill-height>
        <v-row cols="12" dense no-gutter>
          <v-col cols="1" align-self="stretch" align="left">
            <v-btn icon color="white" @click="irpanel0()">
              <v-icon>mdi-home</v-icon>
            </v-btn>
            <v-btn v-if="chip1 || chip2" icon color="white" @click="chipLastclose()">
              <v-icon>mdi-arrow-left-circle</v-icon>
            </v-btn>
          </v-col>
          <v-col cols="5" align-self="stretch" align="left">
            <v-tooltip v-if="titulo != 'INICIO'" right color="similiaverde">
              <template v-if="chip1" v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  v-if="chip1"
                  color="basil"
                  @click.stop="dialogoresena = true"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon>mdi-information</v-icon>
                </v-btn>
              </template>
              <span>Ver más info.</span>
            </v-tooltip>
            <v-chip
              v-if="chip1"
              small
              class="ma-2"
              close
              color="similiaverde"
              @click="chip2close()"
              @click:close="chip1close()"
              >{{ chip1texto }}</v-chip
            >
            <v-chip
              v-if="chip2"
              small
              class="ma-2"
              close
              color="similiaverde"
              @click:close="chip2close()"
              >{{ chip2texto }}</v-chip
            >
          </v-col>
          <v-col cols="4" align="center" align-self="stretch">
            <v-text-field
              v-on:keyup.enter="buscar"
              v-if="titulo != 'Listado de sustancias'"
              v-model="filtrolibrebuscar"
              clearable
              color="white"
              single-line
              filled
              dense
              outlined
              label="Buscar fórmula"
              class="shrink"
              full-width
            ></v-text-field>
          </v-col>
          <v-col cols="2" align="right" align-self="stretch">
            <v-tooltip left color="similiaverde">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  style="white-space: normal"
                  target="_blank"
                  text
                  small
                  class="pt-3"
                  @click="irpanelavanzado()"
                  v-bind="attrs"
                  v-on="on"
                >
                  Buscar<br />Sustancias
                  <v-icon>mdi-magnify</v-icon>
                </v-btn>
              </template>
              <span>Buscar en lista de sustancias</span>
            </v-tooltip>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
    <!--fin de barra del medio con los botones de inicio y titulo-->
    <!-- barra del medio para celulares -->
    <v-card
      v-if="!barraEscritorio"
      color="tiendasimilia"
      width="100%"
      height="118"
      align="center"
    >
      <v-container fluid fill-height>
        <v-row cols="12" dense no-gutter>
          <v-col cols="3" align="left" align-self="stretch">
            <v-btn icon color="white" @click="irpanel0()">
              <v-icon>mdi-home</v-icon>
            </v-btn>
            <v-btn v-if="chip1 || chip2" icon color="white" @click="chipLastclose()">
              <v-icon>mdi-arrow-left-circle</v-icon>
            </v-btn>
          </v-col>
          <v-col cols="5" align="center" align-self="stretch">
            <v-text-field
              v-on:keyup.enter="buscar"
              v-if="titulo != 'Listado de sustancias'"
              v-model="filtrolibrebuscar"
              clearable
              color="white"
              single-line
              filled
              dense
              outlined
              label="Buscar fórmula"
              class="shrink"
              full-width
            ></v-text-field>
          </v-col>
          <v-col cols="4" align="right" align-self="stretch">
            <v-tooltip left color="similiaverde">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  style="white-space: normal"
                  target="_blank"
                  text
                  x-small
                  @click="irpanelavanzado()"
                  v-bind="attrs"
                  v-on="on"
                >
                  Buscar<br />Sustancias
                  <v-icon small>mdi-magnify</v-icon>
                </v-btn>
              </template>
              <span>Buscar en lista de sustancias</span>
            </v-tooltip>
          </v-col>
        </v-row>
        <v-row cols="12" dense no-gutter>
          <v-col cols="12" align-self="stretch" align="left">
            <v-tooltip v-if="titulo != 'INICIO'" right color="similiaverde">
              <template v-if="chip1" v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  v-if="chip1"
                  color="basil"
                  @click.stop="dialogoresena = true"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon>mdi-information</v-icon>
                </v-btn>
              </template>
              <span>Ver más info.</span>
            </v-tooltip>
            <v-chip
              v-if="chip1"
              x-small
              class="ma-1"
              close
              color="similiaverde"
              @click="chip2close()"
              @click:close="chip1close()"
              >{{ chip1texto }}</v-chip
            >
            <v-chip
              v-if="chip2"
              x-small
              class="ma-1"
              close
              color="similiaverde"
              @click:close="chip2close()"
              >{{ chip2texto }}</v-chip
            >
          </v-col>
        </v-row>
      </v-container>
    </v-card>
    <!--fin de barra del medio para celulares -->

    <!--panel resultados del buscador de inicio-->
    <v-container px-6 mt-5 v-if="resultadosiniciovisibles">
      <div id="resultadosinicio">
        <v-data-table
          :headers="headersformula"
          :items="resultados"
          :items-per-page="9999"
          hide-default-footer
          no-data-text="No hay resultados, ingrese otro parametro de búsqueda."
          sort-by="nombre"
          class="elevation-5 similiaverde"
          isMobile
        >
          <template v-slot:top>
            <v-toolbar flat color="similiaverde">
              <!--inicio tarjetainicio en panel resultados inicio-->
              <v-dialog v-model="dialog" max-width="500px" color="tiendasimilia">
                <v-card class="flexcard">
                  <div class="text-center">
                    <v-toolbar color="similiaazul" dark>
                      <v-toolbar-title class="flex text-xs-center">
                        <v-icon>mdi-clipboard-text</v-icon>
                        {{ nro }} {{ nombreformula }}
                      </v-toolbar-title>
                    </v-toolbar>
                  </div>
                  <v-container>
                    <v-row
                      align="center"
                      content-center
                      style="height: 5%"
                      no-gutters
                      class="pt-5"
                    >
                      <v-col cols="12" sm="12" md="12" align="center">
                        <v-text-field
                          v-model="terapia"
                          v-if="terapia != ''"
                          readonly
                          label="Terapia"
                          outlined
                          color="similiaazul"
                          auto-grow
                          :value="terapia"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row align="center" content-center style="height: 5%" no-gutters>
                      <v-col cols="12" sm="12" md="12" align="center">
                        <v-textarea
                          v-model="descripcion"
                          v-if="descripcion != ''"
                          color="similiaazul"
                          outlined
                          label="Descripción"
                          text
                          type="info"
                          auto-grow
                          rows="1"
                          :value="descripcion"
                        >
                        </v-textarea>
                      </v-col>
                    </v-row>
                    <v-row align="center" content-center style="height: 5%" no-gutters>
                      <v-col cols="12" sm="12" md="12" align="center">
                        <v-text-field
                          v-model="forma"
                          v-if="forma != ''"
                          readonly
                          label="Forma"
                          outlined
                          color="similiaazul"
                          rows="1"
                          auto-grow
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row align="center" content-center style="height: 5%" no-gutters>
                      <v-col cols="12" sm="12" md="12" align="center">
                        <v-text-field
                          v-model="cantidad"
                          v-if="cantidad != ''"
                          readonly
                          label="Cantidad"
                          outlined
                          color="similiaazul"
                          rows="1"
                          auto-grow
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row align="center" content-center style="height: 5%" no-gutters>
                      <v-col cols="12" sm="12" md="12" align="center">
                        <v-text-field
                          v-model="posologia"
                          v-if="posologia != ''"
                          readonly
                          label="Posología"
                          outlined
                          color="similiaazul"
                          rows-height="1"
                          rows="1"
                          auto-grow
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row align="center" content-center style="height: 5%" no-gutters>
                      <v-col cols="12" sm="12" md="12" align="center">
                        <v-alert
                          border="top"
                          v-if="descripcion != ''"
                          colored-border
                          type="info"
                          elevation="2"
                        >
                          {{ descripcion }}
                        </v-alert>
                      </v-col>
                    </v-row>
                    <v-row align="center" content-center style="height: 5%" no-gutters>
                      <v-col cols="12" sm="12" md="12" align="center">
                        <v-alert
                          border="left"
                          v-if="contraindicacion != ''"
                          colored-border
                          type="error"
                          elevation="2"
                          prominent
                        >
                          Contraindicaciones: <br />
                          {{ contraindicacion }}
                        </v-alert>
                      </v-col>
                    </v-row>
                    <v-row align="center" content-center style="height: 5%" no-gutters>
                      <v-col cols="12" sm="12" md="12" align="center">
                        <v-btn
                          block
                          text
                          color="similiaazul"
                          elevation="5"
                          rounded
                          outlined
                          dark
                          @click="dialog = false"
                        >
                          CERRAR <v-icon>mdi-check</v-icon>
                        </v-btn>
                        <br />
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card>
              </v-dialog>
              <!--fin tarjetainicio en panel resultados inicio-->
            </v-toolbar>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-icon small centered class="mr-2" @click="infoItem(item)">
              mdi-information-variant
            </v-icon>
          </template>
          <template v-slot:no-data> </template>
        </v-data-table>
      </div>
    </v-container>
    <!-- fin de panel resultados del buscador de inicio-->

    <!-- panel0 es el menu inicial -->
    <v-container id="panel0" v-if="panel0visible" mt-2>
      <v-row align="center" content-center style="height: 5%" class="pb-3">
        <v-col cols="12" sm="12" md="4" align="center">
          <v-btn
            style="white-space: normal"
            color="similiaverde"
            large
            block
            elevation="6"
            @click="panel0click(1)"
          >
            <div>AROMATERAPIA</div></v-btn
          >
        </v-col>
        <v-col cols="12" sm="12" md="4" align="center">
          <v-btn
            style="white-space: normal"
            color="similiaverde"
            large
            block
            elevation="6"
            @click="panel0click(2)"
          >
            <div>AYURVEDA</div>
          </v-btn>
        </v-col>
        <v-col cols="12" sm="12" md="4" align="center">
          <v-btn
            style="white-space: normal"
            color="similiaverde"
            large
            block
            elevation="6"
            @click="panel0click(3)"
          >
            <div>EXTRACTOS</div></v-btn
          >
        </v-col>
      </v-row>
      <v-row align="center" justify="center" style="height: 5%" class="pb-3">
        <v-col cols="12" sm="12" md="4" align="center">
          <v-btn
            style="white-space: normal"
            color="similiaverde"
            large
            block
            elevation="6"
            @click="panel0click(4)"
          >
            FITOTERAPIA</v-btn
          >
        </v-col>
        <v-col cols="12" sm="12" md="4" align="center">
          <v-btn
            style="white-space: normal"
            color="similiaverde"
            large
            block
            elevation="6"
            @click="panel0click(5)"
          >
            SISTEMAS FLORALES</v-btn
          >
        </v-col>
        <v-col cols="12" sm="12" md="4" align="center">
          <v-btn
            style="white-space: normal"
            color="similiaverde"
            large
            block
            elevation="6"
            @click="panel0click(6)"
          >
            HOMEOPATIA</v-btn
          >
        </v-col>
      </v-row>
      <v-row align="center" justify="center" style="height: 5%" class="pb-3">
        <v-col cols="12" sm="12" md="4" align="center">
          <v-btn
            style="white-space: normal"
            color="similiaverde"
            large
            block
            elevation="6"
            @click="panel0click(7)"
          >
            OLIGOELEMENTOS</v-btn
          >
        </v-col>
        <v-col cols="12" sm="12" md="4" align="center">
          <v-btn
            style="white-space: normal"
            color="similiaverde"
            large
            block
            elevation="6"
            @click="panel0click(8)"
          >
            ORTHOMOLECULAR</v-btn
          >
        </v-col>
        <v-col cols="12" sm="12" md="4" align="center">
          <v-btn
            style="white-space: normal"
            color="similiaverde"
            large
            block
            elevation="6"
            @click="panel0click(9)"
          >
            PROBIOTICOS/PREBIOTICOS</v-btn
          >
        </v-col>
      </v-row>
      <v-row align="center" justify="center" style="height: 5%" class="pb-3">
        <v-col cols="12" sm="12" md="4" align="center">
          <v-btn
            style="white-space: normal"
            color="similiaverde"
            large
            block
            elevation="6"
            @click="panel0click(10)"
          >
            PEPTONAS/HIDROLIZADOS</v-btn
          >
        </v-col>
        <v-col cols="12" sm="12" md="4" align="center">
          <v-btn
            style="white-space: normal"
            color="similiaverde"
            large
            block
            elevation="6"
            @click="panel0click(11)"
          >
            TINTURAS MADRE</v-btn
          >
        </v-col>
        <v-col cols="12" sm="12" md="4" align="center">
          <v-btn
            style="white-space: normal"
            color="similiaverde"
            large
            block
            elevation="6"
            @click="panel0click(18)"
          >
            ESTERILES</v-btn
          >
        </v-col>
      </v-row>
      <v-row align="center" justify="center" style="height: 5%" class="pb-3">
        <v-col cols="12" sm="12" md="4" align="center">
          <v-btn
            style="white-space: normal"
            color="similiaverde"
            large
            block
            elevation="6"
            @click="panel0click(16)"
          >
            HONGOS</v-btn
          >
        </v-col>
        <v-col cols="12" sm="12" md="4" align="center">
          <v-btn
            style="white-space: normal"
            color="similiaverde"
            large
            block
            elevation="6"
            @click="panel0click(17)"
          >
            CANNABIS MEDICINAL</v-btn
          >
        </v-col>
        <v-col cols="12" sm="12" md="4" align="center">
          <v-btn
            style="white-space: normal"
            color="similiaverde"
            large
            block
            elevation="6"
            @click="panel0click(12)"
          >
            VETERINARIA NATURAL</v-btn
          >
        </v-col>
      </v-row>
      <v-row align="center" justify="center" style="height: 5%" class="pb-3">
        <v-col cols="12" sm="12" md="4" align="center">
          <v-btn
            style="white-space: normal"
            color="similiaverde"
            large
            block
            elevation="6"
            @click="panel0click(13)"
          >
            BOTIQUINES Y KITS <br />
            HOMEOPATICOS</v-btn
          >
        </v-col>
        <v-col cols="12" sm="12" md="4" align="center">
          <v-btn
            style="white-space: normal"
            color="similiaverde"
            large
            block
            elevation="6"
            @click="panel0click(14)"
          >
            PRODUCTOS NATURALES</v-btn
          >
        </v-col>
        <v-col cols="12" sm="12" md="4" align="center">
          <v-btn
            style="white-space: normal"
            color="similiaverde"
            large
            block
            elevation="6"
            @click="panel0click(15)"
          >
            PRODUCTOS PROPIOS</v-btn
          >
        </v-col>
      </v-row>

      <v-row align="center" justify="center" style="height: 5%" class="pb-3">
        <v-col cols="12" sm="12" md="4" align="center">
          <v-btn
            style="white-space: normal"
            color="similiaverde"
            large
            block
            elevation="6"
            @click="panel0click(19)"
          >
            HORMONAS BIOIDENTICAS</v-btn
          >
        </v-col>
      </v-row>
    </v-container>
    <!-- fin de panel0 -->

    <!-- panel1 dos botones: formulas y sustancias -->
    <v-container id="panel1" v-if="panel1visible">
      <v-row align="center" content-center style="height: 5%" class="pb-3">
        <v-col cols="12" sm="12" md="6" align="center">
          <v-btn
            color="similiaverde"
            large
            block
            elevation="6"
            @click="resultadosustancia('')"
            >SUSTANCIAS</v-btn
          >
        </v-col>
        <v-col cols="12" sm="12" md="6" align="center">
          <v-btn
            color="similiaverde"
            large
            block
            elevation="6"
            @click="resultadoformula('')"
            >FORMULAS</v-btn
          >
        </v-col>
      </v-row>
    </v-container>
    <!-- fin de panel1 -->

    <!-- panel1e dos botones: formulas -->
    <v-container id="panel1e" v-if="panel1evisible">
      <v-row align="center" content-center style="height: 5%">
        <v-col cols="12" sm="12" md="6" align="center">
          <v-btn
            color="similiaverde"
            large
            block
            elevation="6"
            @click="resultadoformula('')"
            >FORMULAS</v-btn
          >
        </v-col>
      </v-row>
    </v-container>
    <!-- fin de panel1e -->

    <!-- panel2 extractos -->
    <v-container id="panel2" v-if="panel2visible">
      <!-- botones que no se si van o no
      <v-row align="center" justify="center" style="height: 5%">
        <v-col cols="6" sm="6" align="center" >
            <v-btn color="similiaverde" large block elevation="6" @click="resultadosustancia('SIMPLES')">SIMPLES</v-btn>
        </v-col>
        <v-col cols="6" sm="6" align="center" >
            <v-btn color="similiaverde" large block elevation="6" @click="resultadosustancia('COMPLEJOS')">COMPLEJOS</v-btn>
        </v-col>
      </v-row> -->
      <v-row align="center" content-center style="height: 5%">
        <v-col cols="12" sm="12" md="12" align="center">
          <v-btn large block color="titulososcuro" depressed> SUSTANCIAS </v-btn>
        </v-col>
      </v-row>
      <v-row align="center" content-center style="height: 5%">
        <v-col cols="12" sm="12" md="4" align="center">
          <v-btn
            color="similiaverde"
            large
            block
            elevation="6"
            @click="resultadosustancia('FLUIDO')"
            >EXTRACTOS FLUIDOS</v-btn
          >
        </v-col>
        <v-col cols="12" sm="12" md="4" align="center">
          <v-btn
            color="similiaverde"
            large
            block
            elevation="6"
            @click="resultadosustancia('GLICOLICO')"
            >EXTRACTOS GLICOLICOS</v-btn
          >
        </v-col>
        <v-col cols="12" sm="12" md="4" align="center">
          <v-btn
            color="similiaverde"
            large
            block
            elevation="6"
            @click="resultadosustancia('SECO')"
            >EXTRACTOS SECOS</v-btn
          >
        </v-col>
      </v-row>
      <v-row align="center" content-center style="height: 5%">
        <v-col cols="12" sm="12" md="12" align="center">
          <v-btn
            color="similiaverde"
            large
            block
            elevation="6"
            @click="resultadosustancia('')"
            >TODAS LAS SUSTANCIAS</v-btn
          >
        </v-col>
      </v-row>

      <v-row align="center" content-center style="height: 5%" class="pt-3">
        <v-col cols="12" sm="12" md="12" align="center">
          <v-btn large block color="titulososcuro" depressed> FORMULAS</v-btn>
        </v-col>
      </v-row>
      <v-row align="center" content-center style="height: 5%">
        <v-col cols="12" sm="12" md="6" align="center">
          <v-btn
            color="similiaverde"
            large
            block
            elevation="6"
            @click="resultadoformula('SIMPLES')"
            >SIMPLES</v-btn
          >
        </v-col>
        <v-col cols="12" sm="12" md="6" align="center">
          <v-btn
            color="similiaverde"
            large
            block
            elevation="6"
            @click="resultadoformula('COMPLEJO')"
            >COMPLEJOS</v-btn
          >
        </v-col>
      </v-row>
    </v-container>
    <!-- fin de panel2 -->

    <!-- panelhomeo -->
    <v-container id="panelhomeo" v-if="panelhomeovisible">
      <v-row align="center" content-center style="height: 5%">
        <v-col cols="12" sm="12" align="center">
          <v-btn color="titulososcuro" depressed large block elevation="6"
            >SUSTANCIAS</v-btn
          >
        </v-col>
      </v-row>
      <v-row align="center" content-center style="height: 5%">
        <v-col cols="12" sm="12" lg="6" align="center">
          <v-btn
            color="similiaverde"
            large
            block
            elevation="6"
            @click="resultadosustancia('')"
            >TODAS LAS SUSTANCIAS</v-btn
          >
        </v-col>
        <v-col cols="12" sm="12" lg="6" align="center">
          <v-btn
            color="similiaverde"
            large
            block
            elevation="6"
            @click="resultadosustancia('LANTANIDOS')"
            >LANTANIDOS</v-btn
          >
        </v-col>
      </v-row>
      <v-row align="center" content-center style="height: 5%" class="pt-3">
        <v-col cols="12" sm="12" lg="6" align="center">
          <v-btn
            color="similiaverde"
            large
            block
            elevation="6"
            @click="resultadosustancia('POCO FRECUENTE')"
            >POCO FRECUENTES</v-btn
          >
        </v-col>
        <v-col cols="12" sm="12" lg="6" align="center">
          <v-btn
            color="similiaverde"
            large
            block
            elevation="6"
            @click="resultadosustancia('FRECUENTE')"
            >FRECUENTES</v-btn
          >
        </v-col>
      </v-row>
      <v-row align="center" content-center style="height: 5%" class="pt-3">
        <v-col cols="12" sm="12" lg="6" align="center">
          <v-btn
            color="similiaverde"
            large
            block
            elevation="6"
            @click="resultadosustancia('NOSODES')"
            >NOSODES - AUTONOSODES</v-btn
          >
        </v-col>
        <v-col cols="12" sm="12" lg="6" align="center">
          <v-btn
            color="similiaverde"
            large
            block
            elevation="6"
            @click="resultadosustancia('SALES DE SCHUSSLER')"
            >SALES DE SCHUSSLER</v-btn
          >
        </v-col>
      </v-row>
      <v-row align="center" content-center style="height: 5%" class="pt-3">
        <v-col cols="12" sm="12" align="center">
          <v-btn large block color="titulososcuro" depressed elevation="6">
            FORMULAS</v-btn
          >
        </v-col>
      </v-row>
      <v-row align="center" content-center style="height: 5%">
        <v-col cols="12" sm="12" align="center">
          <v-btn
            large
            block
            color="similiaverde"
            elevation="6"
            @click="resultadoformulasst('')"
          >
            TODAS LAS FORMULAS</v-btn
          >
        </v-col>
      </v-row>
    </v-container>
    <!-- fin de panelhomeo -->

    <!-- panelprobioticos -->
    <v-container id="panelprobioticos" v-if="panelprobioticosvisible">
      <v-row align="center" content-center>
        <v-col cols="12" sm="12" md="12" align="center">
          <v-btn color="titulososcuro" depressed large block elevation="6">
            SUSTANCIAS</v-btn
          >
        </v-col>
      </v-row>
      <v-row align="center" content-center>
        <v-col cols="12" sm="12" md="12" align="center">
          <v-btn
            color="similiaverde"
            large
            block
            elevation="6"
            @click="resultadosustancia('')"
            >TODAS LAS SUSTANCIAS</v-btn
          >
        </v-col>
      </v-row>
      <v-row align="center" content-center>
        <v-col cols="12" sm="12" md="12" align="center">
          <v-btn large block color="titulososcuro" depressed> FORMULAS</v-btn>
        </v-col>
      </v-row>
      <v-row align="center" content-center>
        <v-col cols="12" sm="12" md="6" align="center">
          <v-btn
            color="similiaverde"
            large
            block
            elevation="6"
            @click="resultadoformula('ALERGIAS RESPIRATORIAS Y PIEL')"
            >ALERGIAS RESPIRATORIAS Y PIEL</v-btn
          >
        </v-col>
        <v-col cols="12" sm="12" md="6" align="center">
          <v-btn
            color="similiaverde"
            large
            block
            elevation="6"
            @click="resultadoformula('TRASTORNOS EN GASTROENTERELOGIA')"
            >TRASTORNOS EN GASTROENTEROLOGÍA</v-btn
          >
        </v-col>
      </v-row>
      <v-row align="center" content-center>
        <v-col cols="12" sm="12" md="6" align="center">
          <v-btn
            color="similiaverde"
            large
            block
            elevation="6"
            @click="resultadoformula('PREVENCION DE LARGO PLAZO')"
            >PREVENCIÓN DE LARGO PLAZO</v-btn
          >
        </v-col>
        <v-col cols="12" sm="12" md="6" align="center">
          <v-btn
            color="similiaverde"
            large
            block
            elevation="6"
            @click="resultadoformula('TRASTORNOS UROGENITALES')"
            >TRASTORNOS UROGENITALES</v-btn
          >
        </v-col>
      </v-row>
      <v-row align="center" content-center>
        <v-col cols="12" sm="12" md="6" align="center">
          <v-btn
            color="similiaverde"
            large
            block
            elevation="6"
            @click="resultadoformula('SISTEMA INMUNOLOGICO')"
            >SISTEMA INMUNOLÓGICO</v-btn
          >
        </v-col>
        <v-col cols="12" sm="12" md="6" align="center">
          <v-btn
            color="similiaverde"
            large
            block
            elevation="6"
            @click="resultadoformula('VAGINITIS Y TRASTORNOS GINECOLOGICOS')"
            >VAGINITIS Y TRASTORNOS GINECOLÓGICOS</v-btn
          >
        </v-col>
      </v-row>
      <v-row align="center" content-center>
        <v-col cols="12" sm="12" md="12" lg="12" align="center">
          <v-btn
            width="550"
            color="similiaverde"
            large
            elevation="6"
            @click="resultadoformula('PEDIATRIA')"
          >
            PEDIATRIA</v-btn
          >
        </v-col>
      </v-row>      
      <v-row align="center" content-center>
        <v-col cols="12" sm="12" align="center">
          <v-btn
            large
            block
            color="similiaverde"
            elevation="6"
            @click="resultadoformulasst('')"
          >
            TODAS LAS FORMULAS</v-btn
          >
        </v-col>
      </v-row>
    </v-container>
    <!-- fin de panelprobioticos -->

    <!-- panelesteriles -->
    <v-container id="panelesteriles" v-if="panelesterilesvisible">
      <v-row align="center" content-center>
        <v-col cols="12" sm="12" md="12" align="center">
          <v-btn large block color="titulososcuro" depressed> FORMULAS</v-btn>
        </v-col>
      </v-row>
      <v-row align="center" content-center>
        <v-col cols="12" sm="12" md="6" align="center">
          <v-btn
            color="similiaverde"
            large
            block
            elevation="6"
            @click="resultadoformula('ORTHOMOLECULAR')"
            >ORTHOMOLECULAR</v-btn
          >
        </v-col>
        <v-col cols="12" sm="12" md="6" align="center">
          <v-btn
            color="similiaverde"
            large
            block
            elevation="6"
            @click="resultadoformula('FLEBOESCLEROSANTES')"
            >FLEBOESCLEROSANTES</v-btn
          >
        </v-col>
      </v-row>
      <v-row align="center" content-center>
        <v-col cols="12" sm="12" md="6" align="center">
          <v-btn
            color="similiaverde"
            large
            block
            elevation="6"
            @click="resultadoformula('MESOTERAPIA')"
            >MESOTERAPIA</v-btn
          >
        </v-col>
        <v-col cols="12" sm="12" md="6" align="center">
          <v-btn
            color="similiaverde"
            large
            block
            elevation="6"
            @click="resultadoformula('PRODUCTOS AUXILIARES')"
            >PRODUCTOS AUXILIARES</v-btn
          >
        </v-col>
      </v-row>
      <v-row align="center" content-center>
        <v-col cols="12" sm="12" align="center">
          <v-btn
            large
            block
            color="similiaverde"
            elevation="6"
            @click="resultadoformulasst('')"
          >
            TODAS LAS FORMULAS</v-btn
          >
        </v-col>
      </v-row>
    </v-container>
    <!-- fin de panelesteriles -->

    <!-- panelflorales -->
    <v-container id="panelflorales" v-if="panelfloralesvisible">
      <v-row align="center" content-center style="height: 5%">
        <v-col cols="12" sm="12" md="12" align="center">
          <v-btn large block color="titulososcuro" depressed> SISTEMAS FLORALES</v-btn>
        </v-col>
      </v-row>
      <v-row align="center" content-center style="height: 5%">
        <v-col cols="12" sm="12" md="12" lg="6" align="center">
          <v-btn
            color="similiaverde"
            large
            block
            elevation="6"
            @click="resultadosustancia('FLORALES BACH')"
            >FLORES DE BACH</v-btn
          >
        </v-col>
        <v-col cols="12" sm="12" md="12" lg="6" align="center">
          <v-btn
            color="similiaverde"
            large
            block
            elevation="6"
            @click="resultadosustancia('FLORALES BUSH')"
            >FLORES DE BUSH</v-btn
          >
        </v-col>
      </v-row>
      <v-row align="center" content-center style="height: 5%" class="pt-3">
        <v-col cols="12" sm="12" md="12" lg="6" align="center">
          <v-btn
            color="similiaverde"
            large
            block
            elevation="6"
            @click="resultadosustancia('FLORALES CALIFORNIA')"
          >
            FLORES DE CALIFORNIA</v-btn
          >
        </v-col>
        <v-col cols="12" sm="12" md="12" lg="6" align="center">
          <v-btn
            color="similiaverde"
            large
            block
            elevation="6"
            @click="resultadosustancia('FLORALES RAFF')"
            >FLORES DE RAFF</v-btn
          >
        </v-col>
      </v-row>
      <v-row align="center" content-center style="height: 5%" class="pt-3">
        <v-col cols="12" sm="12" md="12" lg="12" align="center">
          <v-btn
            width="550"
            color="similiaverde"
            large
            elevation="6"
            @click="resultadosustancia('FLORALES SAINT GERMAIN')"
          >
            FLORES DE SAINT GERMAIN</v-btn
          >
        </v-col>
      </v-row>
      <v-row align="center" content-center style="height: 5%" class="pt-3">
        <v-col cols="12" sm="12" align="center">
          <v-btn large block color="titulososcuro" depressed elevation="6">
            FORMULAS</v-btn
          >
        </v-col>
      </v-row>
      <v-row align="center" content-center style="height: 5%">
        <v-col cols="12" sm="12" align="center">
          <v-btn
            large
            block
            color="similiaverde"
            elevation="6"
            @click="resultadoformula('')"
          >
            TODAS LAS FORMULAS</v-btn
          >
        </v-col>
      </v-row>
    </v-container>
    <!-- fin de panelflorales -->

    <!-- paneltinturas -->
    <v-container id="paneltinturas" v-if="paneltinturasvisible">
      <v-row align="center" content-center style="height: 5%">
        <v-col cols="12" sm="12" align="center">
          <v-btn color="titulososcuro" depressed large block elevation="6">
            SUSTANCIAS</v-btn
          >
        </v-col>
      </v-row>
      <v-row align="center" content-center style="height: 5%">
        <v-col cols="12" sm="12" align="center">
          <v-btn
            color="similiaverde"
            large
            block
            elevation="6"
            @click="resultadosustancia('')"
            >TODAS LAS TINTURAS</v-btn
          >
        </v-col>
      </v-row>
      <v-row align="center" content-center style="height: 5%" class="pt-3">
        <v-col cols="12" sm="12" align="center">
          <v-btn large block color="titulososcuro" depressed> FORMULAS</v-btn>
        </v-col>
      </v-row>
      <v-row align="center" content-center style="height: 5%">
        <v-col cols="6" sm="6" align="center">
          <v-btn
            color="similiaverde"
            large
            block
            elevation="6"
            @click="resultadoformula('SIMPLES')"
            >SIMPLES</v-btn
          >
        </v-col>
        <v-col cols="6" sm="6" align="center">
          <v-btn
            color="similiaverde"
            large
            block
            elevation="6"
            @click="resultadoformula('COMPLEJAS')"
            >COMPLEJAS</v-btn
          >
        </v-col>
      </v-row>
    </v-container>
    <!-- fin de paneltinturas -->

    <!-- panelbotiquin -->
    <v-container id="panelbotiquin" v-if="panelbotiquinvisible">
      <v-row align="center" content-center style="height: 5%">
        <v-col cols="12" sm="12" align="center">
          <v-btn
            color="similiaverde"
            large
            block
            elevation="6"
            @click="resultadoformula('')"
            >BOTIQUINES</v-btn
          >
        </v-col>
      </v-row>
    </v-container>
    <!-- fin de panelbotiquines -->

    <!-- panelvet  -->
    <v-container id="panel1" v-if="panelvetvisible">
      <v-row align="center" content-center style="height: 5%">
        <v-col cols="12" sm="12" align="center">
          <v-btn
            color="similiaverde"
            large
            block
            elevation="6"
            @click="resultadoformula('')"
            >FORMULAS</v-btn
          >
        </v-col>
      </v-row>
    </v-container>
    <!-- fin de panelvet -->

    <!-- panelhormonas  -->
    <v-container id="panelhormonas" v-if="panelhormonasvisible">
      <v-row align="center" content-center style="height: 5%">
        <v-col cols="12" sm="12" align="center">
          <v-btn
            color="similiaverde"
            large
            block
            elevation="6"
            @click="resultadosustancia('')"
            >TODAS LAS SUSTANCIAS</v-btn
          >
        </v-col>
      </v-row>
    </v-container>
    <!-- fin de panelvet -->

    <!-- panelnaturalesypropios -->
    <v-container id="panelnatyprop" v-if="panelnatypropvisible">
      <v-row align="center" content-center style="height: 5%" class="pb-3">
        <v-col cols="12" sm="12" md="12" align="center">
          <v-btn
            color="similiaverde"
            large
            block
            elevation="6"
            @click="resultadoformula('')"
            >VER PRODUCTOS</v-btn
          >
        </v-col>
      </v-row>
    </v-container>
    <!-- fin de panelnaturalesypropios -->

    <v-divider></v-divider>

    <!-- panelformulas -->
    <div v-if="barraEscritorio">
      <v-container px-6 mt-5 id="panelformulas" v-if="panelformulasvisible">
        <div id="resultados">
          <v-data-table
            :items-per-page="9999"
            :headers="headersformula"
            :items="resultados"
            hide-default-footer
            no-data-text="Buscando fórmulas. Aguarde un momento..."
            sort-by="nombre"
            class="elevation-5 similiaverde"
            @click:row="infoItem"
          >
            <template v-slot:top>
              <v-toolbar flat color="similiaverde"
                ><v-toolbar-title class="flex text-center tiendasimilia" color="black"
                  ><B>FORMULAS</B></v-toolbar-title
                >

                <!--inicio tarjetaformula del panel formula-->
                <v-dialog v-model="dialog" max-width="500px" color="tiendasimilia">
                  <v-card class="flexcard">
                    <div class="text-center">
                      <v-toolbar color="similiaazul" dark>
                        <v-toolbar-title class="flex text-start"
                          >{{ nro }}<br />{{ nombreformula }}</v-toolbar-title
                        >
                        <v-spacer></v-spacer>
                        <v-btn color="white" @click="dialog = false" icon>
                          <v-icon>mdi-close</v-icon>
                        </v-btn>
                      </v-toolbar>
                    </div>
                    <v-container>
                      <v-row
                        align="center"
                        content-center
                        style="height: 5%"
                        no-gutters
                        class="pt-5"
                      >
                        <v-col cols="12" sm="12" md="12" align="center">
                          <v-text-field
                            v-model="terapia"
                            v-if="terapia != ''"
                            readonly
                            label="Terapia"
                            outlined
                            color="similiaazul"
                            rows="1"
                            auto-grow
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row align="center" content-center style="height: 5%" no-gutters>
                        <v-col cols="12" sm="12" md="12" align="center">
                          <v-textarea
                            border="left"
                            v-if="descripcion != ''"
                            color="similiaazul"
                            outlined
                            prominent
                            rows="1"
                            auto-grow
                            type="info"
                            :value="descripcion"
                            label="Descripción"
                          >
                          </v-textarea>
                        </v-col>
                      </v-row>
                      <v-row align="center" content-center style="height: 5%" no-gutters>
                        <v-col cols="12" sm="12" md="12" align="center">
                          <v-text-field
                            v-model="forma"
                            v-if="forma != ''"
                            readonly
                            label="Forma"
                            outlined
                            color="similiaazul"
                            auto-grow
                            :value="forma"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row align="center" content-center style="height: 5%" no-gutters>
                        <v-col cols="12" sm="12" md="12" align="center">
                          <v-textarea
                            v-model="cantidad"
                            v-if="cantidad != ''"
                            readonly
                            label="Cantidad"
                            outlined
                            color="similiaazul"
                            rows="1"
                            auto-grow
                            :value="cantidad"
                          ></v-textarea>
                        </v-col>
                      </v-row>
                      <v-row align="center" content-center style="height: 5%" no-gutters>
                        <v-col cols="12" sm="12" md="12" align="center">
                          <v-textarea
                            v-model="formula"
                            v-if="formula != ''"
                            label="Formula"
                            readonly
                            outlined
                            color="similiaazul"
                            rows="1"
                            auto-grow
                            :value="formula"
                          ></v-textarea>
                        </v-col>
                      </v-row>
                      <v-row align="center" content-center style="height: 5%" no-gutters>
                        <v-col cols="12" sm="12" md="12" align="center">
                          <v-textarea
                            v-model="posologia"
                            v-if="posologia != ''"
                            label="Posología"
                            readonly
                            outlined
                            color="similiaazul"
                            rows="1"
                            auto-grow
                            :value="posologia"
                          ></v-textarea>
                        </v-col>
                      </v-row>
                      <v-row align="center" content-center style="height: 5%" no-gutters>
                        <v-col cols="12" sm="12" md="12" align="center">
                          <v-alert
                            border="left"
                            v-if="contraindicacion != ''"
                            colored-border
                            type="error"
                            elevation="2"
                            prominent
                          >
                            Contraindicaciones: <br />
                            {{ contraindicacion }}
                          </v-alert>
                        </v-col>
                      </v-row>
                      <v-row align="center" content-center style="height: 5%" no-gutters>
                        <v-col cols="12" sm="12" md="12" align="center">
                          <v-btn
                            block
                            text
                            color="similiaazul"
                            elevation="5"
                            rounded
                            outlined
                            dark
                            @click="dialog = false"
                          >
                            CERRAR <v-icon>mdi-check</v-icon>
                          </v-btn>
                          <br />
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card>
                </v-dialog>
                <!--fin tarjetaformula del panel formula-->
              </v-toolbar>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <v-icon small centered class="mr-2" @click="infoItem(item)">
                mdi-information-variant
              </v-icon>
            </template>
            <template v-slot:no-data> </template>
          </v-data-table>
        </div>
      </v-container>
    </div>
    <div v-else>
      <v-container px-2 mt-1 id="panelformulas" v-if="panelformulasvisible">
        <div id="resultados">
          <v-data-table
            :headers="formulaheadersCelu"
            :items="resultados"
            :items-per-page="9999"
            @click:row="infoItem"
            no-data-text="Buscando fórmulas. Aguarde un momento..."
            sort-by="nombre"
            class="elevation-5 similiaverde"
            hide-default-header
            hide-default-footer
            mobile-breakpoint=""
          >
            <template v-slot:top>
              <v-toolbar flat color="verdeclarito">
                <v-toolbar-title class="flex text-center tiendasimilia" color="black"
                  ><B>FORMULAS</B></v-toolbar-title
                >
                <!--inicio tarjetaformula del panel formula-->
                <v-dialog v-model="dialog" max-width="500px" color="tiendasimilia">
                  <v-card class="flexcard">
                    <div class="text-center">
                      <v-toolbar color="similiaazul" dark>
                        <v-toolbar-title class="flex text-left"
                          >{{ nro }}<br />{{ nombreformula }}</v-toolbar-title
                        >
                        <v-spacer></v-spacer>
                        <v-btn color="white" @click="dialog = false" icon>
                          <v-icon>mdi-close</v-icon>
                        </v-btn>
                      </v-toolbar>
                    </div>
                    <v-container>
                      <v-row
                        align="center"
                        content-center
                        style="height: 5%"
                        no-gutters
                        class="pt-5"
                      >
                        <v-col cols="12" sm="12" md="12" align="center">
                          <v-text-field
                            v-model="terapia"
                            v-if="terapia != ''"
                            readonly
                            label="Terapia"
                            outlined
                            color="similiaazul"
                            rows="1"
                            auto-grow
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row align="center" content-center style="height: 5%" no-gutters>
                        <v-col cols="12" sm="12" md="12" align="center">
                          <v-textarea
                            border="left"
                            v-if="descripcion != ''"
                            color="similiaazul"
                            outlined
                            prominent
                            rows="1"
                            auto-grow
                            type="info"
                            :value="descripcion"
                            label="Descripción"
                          >
                          </v-textarea>
                        </v-col>
                      </v-row>
                      <v-row align="center" content-center style="height: 5%" no-gutters>
                        <v-col cols="12" sm="12" md="12" align="center">
                          <v-text-field
                            v-model="forma"
                            v-if="forma != ''"
                            readonly
                            label="Forma"
                            outlined
                            color="similiaazul"
                            auto-grow
                            :value="forma"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row align="center" content-center style="height: 5%" no-gutters>
                        <v-col cols="12" sm="12" md="12" align="center">
                          <v-textarea
                            v-model="cantidad"
                            v-if="cantidad != ''"
                            readonly
                            label="Cantidad"
                            outlined
                            color="similiaazul"
                            rows="1"
                            auto-grow
                            :value="cantidad"
                          ></v-textarea>
                        </v-col>
                      </v-row>
                      <v-row align="center" content-center style="height: 5%" no-gutters>
                        <v-col cols="12" sm="12" md="12" align="center">
                          <v-textarea
                            v-model="formula"
                            v-if="formula != ''"
                            label="Formula"
                            readonly
                            outlined
                            color="similiaazul"
                            rows="1"
                            auto-grow
                            :value="formula"
                          ></v-textarea>
                        </v-col>
                      </v-row>
                      <v-row align="center" content-center style="height: 5%" no-gutters>
                        <v-col cols="12" sm="12" md="12" align="center">
                          <v-textarea
                            v-model="posologia"
                            v-if="posologia != ''"
                            label="Posología"
                            readonly
                            outlined
                            color="similiaazul"
                            rows="1"
                            auto-grow
                            :value="posologia"
                          ></v-textarea>
                        </v-col>
                      </v-row>
                      <v-row align="center" content-center style="height: 5%" no-gutters>
                        <v-col cols="12" sm="12" md="12" align="center">
                          <v-alert
                            border="left"
                            v-if="contraindicacion != ''"
                            colored-border
                            type="error"
                            elevation="2"
                            prominent
                          >
                            Contraindicaciones: <br />
                            {{ contraindicacion }}
                          </v-alert>
                        </v-col>
                      </v-row>
                      <v-row align="center" content-center style="height: 5%" no-gutters>
                        <v-col cols="12" sm="12" md="12" align="center">
                          <v-btn
                            block
                            text
                            color="similiaazul"
                            elevation="5"
                            rounded
                            outlined
                            dark
                            @click="dialog = false"
                          >
                            CERRAR <v-icon>mdi-check</v-icon>
                          </v-btn>
                          <br />
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card>
                </v-dialog>
                <!--fin tarjetaformula del panel formula-->
              </v-toolbar>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <v-btn
                elevation="3"
                class="mt-2"
                icon
                x-small
                center
                color="tiendasimilia"
                @click="infoItem(item)"
              >
                <v-icon>mdi-information-variant</v-icon>
              </v-btn>
            </template>
            <template v-slot:[`item.nombreformula`]="{ item }">
              <div align="left">
                <span
                  ><B>{{ item.nombreformula.trim() }}</B
                  ><br /><I>{{ item.nro }}</I></span
                >
              </div>
            </template>
          </v-data-table>
        </div>
      </v-container>
    </div>
    <!-- fin de panelformulas -->

    <!-- panelsustancias -->
    <div v-if="barraEscritorio">
      <v-container px-6 mt-5 id="panelsustancias" v-if="panelsustanciasvisible">
        <div id="sustanciasresultados">
          <v-data-table
            :headers="sustanciaheaders"
            :items="sustanciaresultados"
            :items-per-page="9999"
            @click:row="infoItem"
            hide-default-footer
            no-data-text="Buscando sustancias. Aguarde un momento..."
            sort-by="nombre"
            class="elevation-5 similiaverde"
          >
            <template v-slot:top>
              <v-toolbar flat color="similiaverde">
                <v-toolbar-title class="flex text-center tiendasimilia" color="black"
                  ><B>SUSTANCIAS</B></v-toolbar-title
                >
                <!-- inicio tarjetasustancia de sustancias-->
                <v-dialog v-model="dialog" max-width="500px" color="tiendasimilia">
                  <v-card class="flexcard">
                    <div class="text-center">
                      <v-toolbar color="similiaverde" dark>
                        <v-toolbar-title class="flex text-start"
                          >{{ nombre }} {{ parte }} {{ chakra }}</v-toolbar-title
                        >
                        <v-spacer></v-spacer>
                        <v-btn color="white" @click="dialog = false" icon>
                          <v-icon>mdi-close</v-icon>
                        </v-btn>
                      </v-toolbar>
                    </div>
                    <v-container>
                      <h5 class="text-center">
                        <br />Para mas información contacte a nuestros laboratorios.<br />
                      </h5>
                      <v-divider class="pb-10"></v-divider>
                    </v-container>
                  </v-card>
                </v-dialog>
                <!-- fin tarjetasustancia de sustancias-->
              </v-toolbar>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <v-icon small centered class="mr-2" @click="infoItem(item)">
                mdi-information-variant
              </v-icon>
            </template>

            <template v-slot:no-data> </template>
          </v-data-table>
        </div>
      </v-container>
    </div>
    <div v-else>
      <v-container px-2 mt-1 id="panelsustancias" v-if="panelsustanciasvisible">
        <div id="sustanciasresultados">
          <v-data-table
            :headers="sustanciaheadersCelu"
            :items="sustanciaresultados"
            :items-per-page="9999"
            @click:row="infoItem"
            no-data-text="Buscando sustancias. Aguarde un momento..."
            sort-by="nombre"
            class="elevation-5 similiaverde"
            hide-default-header
            hide-default-footer
            mobile-breakpoint=""
          >
            <template v-slot:top>
              <v-toolbar flat color="verdeclarito">
                <v-toolbar-title class="flex text-center tiendasimilia" color="black"
                  ><B>SUSTANCIAS</B></v-toolbar-title
                >
                <!-- inicio tarjetasustancia de sustancias-->
                <v-dialog v-model="dialog" max-width="500px" color="tiendasimilia">
                  <v-card class="flexcard">
                    <div class="text-center">
                      <v-toolbar color="similiaverde" dark>
                        <v-toolbar-title class="flex text-start"
                          >{{ nombre }} {{ parte }} {{ chakra }}</v-toolbar-title
                        >
                        <v-spacer></v-spacer>
                        <v-btn color="white" @click="dialog = false" icon>
                          <v-icon>mdi-close</v-icon>
                        </v-btn>
                      </v-toolbar>
                    </div>
                    <v-container>
                      <h5 class="text-center">
                        <br />Para mas información contacte a nuestros laboratorios.<br />
                      </h5>
                      <v-divider class="pb-10"></v-divider>
                    </v-container>
                  </v-card>
                </v-dialog>
                <!-- fin tarjetasustancia de sustancias-->
              </v-toolbar>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <v-btn
                elevation="3"
                class="mt-2"
                icon
                x-small
                center
                color="tiendasimilia"
                @click="infoItem(item)"
              >
                <v-icon>mdi-information-variant</v-icon>
              </v-btn>
            </template>
            <template v-slot:[`item.nombre`]="{ item }">
              <div align="left">
                <span
                  ><B>{{ item.nombre.trim() }}</B
                  ><br /><I>{{ item.sinonimias }}</I></span
                >
              </div>
            </template>
          </v-data-table>
        </div>
      </v-container>
    </div>
    <!-- fin de panelsustancias -->

    <!-- panelavanzado -->
    <v-container id="panelavanzado" v-if="panelavanzadovisible">
      <BuscadorSustancia />
    </v-container>
    <!-- fin de panelavanzado -->

    <!-- dialogo resenaa muestra info/reseña de la terapia del titulo -->
    <template>
      <div>
        <v-dialog
          v-model="dialogoresena"
          border="top"
          type="info"
          elevation="2"
          color="tiendasimilia"
          width="550"
        >
          <v-card color="tiendasimilia">
            <v-app-bar flat color="rgba(0, 0, 0, 0)">
              <v-toolbar-title class="title white--text pl-0">{{
                terapiabuscar
              }}</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn color="white" @click="dialogoresena = false" icon>
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-app-bar>
            <v-alert>
              <div v-if="barraEscritorio">
                <v-img
                  src="./../assets/resenas/ACEITESESCENCIALES.png"
                  width="500"
                  height="1400"
                  contain
                  v-if="resenaaceitesescenciales"
                ></v-img>
                <v-img
                  src="./../assets/resenas/AYURVEDICO.png"
                  width="500"
                  height="250"
                  contain
                  v-if="resenaayurvedico"
                ></v-img>
                <v-img
                  src="./../assets/resenas/BOTIQUINES.png"
                  width="500"
                  height="150"
                  contain
                  v-if="resenabotiquines"
                ></v-img>
                <v-img
                  src="./../assets/resenas/EXTRACTOS.png"
                  width="500"
                  height="150"
                  contain
                  v-if="resenaextractos"
                ></v-img>
                <v-img
                  src="./../assets/resenas/FITOTERAPIA.png"
                  width="500"
                  height="200"
                  contain
                  v-if="resenafitoterapia"
                ></v-img>
                <v-img
                  src="./../assets/resenas/FLORALES.png"
                  width="500"
                  height="400"
                  contain
                  v-if="resenaflorales"
                ></v-img>
                <v-img
                  src="./../assets/resenas/HOMEOPATIA.png"
                  width="500"
                  height="290"
                  contain
                  v-if="resenahomeopatia"
                ></v-img>
                <v-img
                  src="./../assets/resenas/NATURALES.png"
                  width="500"
                  height="150"
                  contain
                  v-if="resenanaturales"
                ></v-img>
                <v-img
                  src="./../assets/resenas/OLIGOELEMENTOS.png"
                  width="500"
                  height="150"
                  contain
                  v-if="resenaoligoelementos"
                ></v-img>
                <v-img
                  src="./../assets/resenas/ORTHOMOLECULAR.png"
                  width="500"
                  height="220"
                  contain
                  v-if="resenaorthomolecular"
                ></v-img>
                <v-img
                  src="./../assets/resenas/PEPTONASHIDROLIZADOS.png"
                  width="500"
                  height="200"
                  contain
                  v-if="resenapeptonashidrolizados"
                ></v-img>
                <v-img
                  src="./../assets/resenas/PROBIOTICOS.png"
                  width="500"
                  height="4000"
                  contain
                  v-if="resenaprobioticos"
                ></v-img>
                <v-img
                  src="./../assets/resenas/PROPIOS.png"
                  width="500"
                  height="150"
                  contain
                  v-if="resenapropios"
                ></v-img>
                <v-img
                  src="./../assets/resenas/TINTURASMADRE.png"
                  width="500"
                  height="150"
                  contain
                  v-if="resenatinturasmadre"
                ></v-img>
                <v-img
                  src="./../assets/resenas/VETERINARIA.png"
                  width="500"
                  height="150"
                  contain
                  v-if="resenaveterinaria"
                ></v-img>
              </div>
              <div v-else>
                <v-img
                  src="./../assets/resenas/ACEITESESCENCIALES.png"
                  height="1100"
                  aspect-ratio="1"
                  contain
                  v-if="resenaaceitesescenciales"
                ></v-img>
                <v-img
                  src="./../assets/resenas/AYURVEDICO.png"
                  aspect-ratio="1"
                  height="250"
                  contain
                  v-if="resenaayurvedico"
                ></v-img>
                <v-img
                  src="./../assets/resenas/BOTIQUINES.png"
                  aspect-ratio="1"
                  height="150"
                  contain
                  v-if="resenabotiquines"
                ></v-img>
                <v-img
                  src="./../assets/resenas/EXTRACTOS.png"
                  aspect-ratio="1"
                  height="100"
                  contain
                  v-if="resenaextractos"
                ></v-img>
                <v-img
                  src="./../assets/resenas/FITOTERAPIA.png"
                  aspect-ratio="1"
                  height="200"
                  contain
                  v-if="resenafitoterapia"
                ></v-img>
                <v-img
                  src="./../assets/resenas/FLORALES.png"
                  aspect-ratio="1"
                  height="400"
                  contain
                  v-if="resenaflorales"
                ></v-img>
                <v-img
                  src="./../assets/resenas/HOMEOPATIA.png"
                  aspect-ratio="1"
                  height="290"
                  contain
                  v-if="resenahomeopatia"
                ></v-img>
                <v-img
                  src="./../assets/resenas/NATURALES.png"
                  aspect-ratio="1"
                  height="100"
                  contain
                  v-if="resenanaturales"
                ></v-img>
                <v-img
                  src="./../assets/resenas/OLIGOELEMENTOS.png"
                  aspect-ratio="1"
                  height="100"
                  contain
                  v-if="resenaoligoelementos"
                ></v-img>
                <v-img
                  src="./../assets/resenas/ORTHOMOLECULAR.png"
                  aspect-ratio="1"
                  height="220"
                  contain
                  v-if="resenaorthomolecular"
                ></v-img>
                <v-img
                  src="./../assets/resenas/PEPTONASHIDROLIZADOS.png"
                  aspect-ratio="1"
                  height="200"
                  contain
                  v-if="resenapeptonashidrolizados"
                ></v-img>
                <v-img
                  src="./../assets/resenas/PROBIOTICOS.png"
                  aspect-ratio="1"
                  height="3200"
                  contain
                  v-if="resenaprobioticos"
                ></v-img>
                <v-img
                  src="./../assets/resenas/PROPIOS.png"
                  aspect-ratio="1"
                  height="100"
                  contain
                  v-if="resenapropios"
                ></v-img>
                <v-img
                  src="./../assets/resenas/TINTURASMADRE.png"
                  aspect-ratio="1"
                  height="150"
                  contain
                  v-if="resenatinturasmadre"
                ></v-img>
                <v-img
                  src="./../assets/resenas/VETERINARIA.png"
                  aspect-ratio="1"
                  height="150"
                  contain
                  v-if="resenaveterinaria"
                ></v-img>
              </div>
            </v-alert>
          </v-card>
        </v-dialog>
      </div>
    </template>
    <!-- fin de dialogoresena -->
  </v-card>
</template>

<script>
import BuscadorSustancia from "../components/BuscadorSustancia";
import axios from "axios";
import ResizeText from "vue-resize-text";
import VueScreenSize from "vue-screen-size";
import VueRouter from "vue-router";

export default {
  mixins: [VueScreenSize.VueScreenSizeMixin],
  components: {
    BuscadorSustancia,
  },
  data() {
    return {
      titulo: "INICIO",
      chip1: false,
      chip2: false,
      chip1texto: "",
      chip2texto: "",
      lastChip: 0,
      lastindexbutton: 0,
      barraEscritorio: true,
      resenaactiva: "",
      dialogoresena: false,
      resenaaceitesescenciales: false,
      resenaayurvedico: false,
      resenahongos: false,
      resenacannabis: false,
      resenaesteriles: false,
      resenabotiquines: false,
      resenaextractos: false,
      resenafitoterapia: false,
      resenaflorales: false,
      resenahomeopatia: false,
      resenanaturales: false,
      resenaoligoelementos: false,
      resenaorthomolecular: false,
      resenapeptonashidrolizados: false,
      resenaprobioticos: false,
      resenapropios: false,
      resenatinturasmadre: false,
      resenaveterinaria: false,
      panel0visible: true,
      panel1visible: false,
      panelhormonasvisible: false,
      panel1evisible: false,
      panel2visible: false,
      panelformulasvisible: false,
      panelsustanciasvisible: false,
      panelavanzadovisible: false,
      panelhomeovisible: false,
      panelfloralesvisible: false,
      paneltinturasvisible: false,
      panelbotiquinvisible: false,
      resultadosiniciovisibles: false,
      panelprobioticosvisible: false,
      panelesterilesvisible: false,
      panelvetvisible: false,
      panelnatypropvisible: false,
      terapiabuscar: "",
      subterapiabuscar: "",
      filtrolibrebuscar: "",
      ramabuscar: "",
      patologiabuscar: "",
      sustanciabuscar: "",
      hasSaved: false,
      model: null,
      terapias: [],
      ramas: [],
      patologias: [],
      sustancias: [],
      selectedterapia: { idterapia: 0, terapia: "" },
      selectedrama: { idrama: 0, rama: "" },
      selectedpatologia: { idpatologia: 0, patologia: "" },
      selectedsustancia: { idsustancia: 0, nombre: "" },
      dialog: false,
      nombreformula: "",
      nro: "",
      contraindicacion: "",
      forma: "",
      cantidad: "",
      posologia: "",
      formula: "",
      descripcion: "",
      terapia: "",
      subterapia: "",
      rama: "",
      patologia: "",
      tipo: "",
      nombre: "",
      parte: "",
      chakra: "",
      toxicidadinterna: "",
      concentracion: "",
      accionterapeutica: "",
      resena: "",
      headersformula: [
        { text: "Codigo", value: "nro" },
        { text: "Nombre", align: "start", value: "nombreformula" },
        { text: "Descripción", value: "referencias" },
        { text: "+info", value: "actions", sortable: false },
      ],
      sustanciaheaders: [
        { text: "Nombre", align: "start", value: "nombre", width: "30%" },
        { text: "Referencia / Sinonimias", value: "sinonimias", width: "60%" },
        { text: "+info", value: "actions", sortable: false },
      ],
      sustanciaheadersCelu: [
        { text: "+info", value: "actions", align: "left", sortable: false, width: "15%" },
        { text: "Nombre", align: "left", value: "nombre", width: "85%" },
      ],
      formulaheadersCelu: [
        { text: "+info", value: "actions", align: "left", sortable: false, width: "15%" },
        { text: "Nombre", align: "left", value: "nombreformula", width: "85%" },
      ],
      sustanciaresultados: [],
      resultados: [],
      editedIndex: -1,
      editedItem: {
        terapia: "",
        subterapia: "",
        rama: "",
        patologia: "",
        tipo: "",
        nombreformula: "",
        nro: "",
        contraindicacion: "",
        descripcion: "",
        forma: "",
        cantidad: "",
        posologia: "",
        formula: "",
        nombre: "",
        parte: "",
        chakra: "",
        toxicidadinterna: "",
        concentracion: "",
        accionterapeutica: "",
        resena: "",
      },
      defaultItem: {
        terapia: "",
        subterapia: "",
        rama: "",
        patologia: "",
        tipo: "",
        nombreformula: "",
        nro: "",
        contraindicacion: "",
        descripcion: "",
        forma: "",
        cantidad: "",
        posologia: "",
        formula: "",
        nombre: "",
        parte: "",
        chakra: "",
        toxicidadinterna: "",
        concentracion: "",
        accionterapeutica: "",
        resena: "",
      },
    };
  },

  directives: {
    ResizeText,
  },

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "New Item" : "Edit Item";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  created() {
    this.initialize();

    let uri = window.location.href.split("?");
    if (uri.length == 2) {
      let vars = uri[1].split("&");
      let getVars = {};
      let tmp = "";
      vars.forEach(function (v) {
        tmp = v.split("=");
        if (tmp.length == 2) getVars[tmp[0]] = tmp[1];
      });

      if (tmp[0] == "probioticos") {
        this.panel0click(9);
      }

      if (tmp[0] == "ayurveda") {
        this.panel0click(2);
      }

      if (tmp[0] == "esteriles") {
        this.panel0click(18);
        // this.irpanelesteriles("ESTERILES");
        // this.setresenaactiva("ESTERILES");
        // this.resultadoformula('');
      }

      if (tmp[0] == "cannabis") {
        //   this.panel0click(18);
        this.irpanel1("CANNABIS MEDICINAL");
        this.setresenaactiva("CANNABIS MEDICINAL");
        this.resultadoformula('');
      }

      // if (tmp[0] == "pruebaesteriles") {
      //   this.panel0click(18);
      //   this.irpanel1e("ESTERILES");
      //   this.setresenaactiva("ESTERILES");
      //   this.resultadoformula('');
      // }

      //console.log(getVars);
      // do
    }
  },

  methods: {
    initialize() {
      if (this.$vssWidth > 600) {
        this.barraEscritorio = true;
      } else {
        this.barraEscritorio = false;
      }
    },

    close() {
      this.dialog = false;
    },

    infoItem(item) {
      this.nro = item.nro;
      this.forma = item.forma;
      this.formula = item.formula;
      this.posologia = item.posologia;
      this.patologia = item.patologia;
      this.cantidad = item.cantidad;
      this.contraindicacion = item.contraindicacion;
      this.terapia = item.terapia;
      this.subterapia = item.subterapia;
      this.nombreformula = item.nombreformula;
      this.descripcion = item.descripcion;
      this.nombre = item.nombre;
      this.parte = item.parte;
      this.chakra = item.chakra;
      this.toxicidadinterna = item.toxicidadinterna;
      this.accionterapeutica = item.accionterapeutica;
      this.resena = item.resena;
      this.dialog = true;
    },

    save() {
      this.isEditing = !this.isEditing;
      this.hasSaved = true;
    },

    panel0click: function (buttonindex) {
      this.lastindexbutton = buttonindex;

      if (buttonindex == 1) {
        this.irpanel1("AROMATERAPIA");
        this.setresenaactiva("AROMATERAPIA");
      }

      if (buttonindex == 2) {
        this.irpanel1("AYURVEDA");
        this.setresenaactiva("AYURVEDA");
      }

      if (buttonindex == 3) {
        this.irpanel2("EXTRACTOS");
        this.setresenaactiva("EXTRACTOS");
      }

      if (buttonindex == 4) {
        this.irpanel1("FITOTERAPIA");
        this.setresenaactiva("FITOTERAPIA");
      }

      if (buttonindex == 5) {
        this.irpanelflorales("FLORALES");
        this.setresenaactiva("FLORALES");
      }

      if (buttonindex == 6) {
        this.irpanelhomeo("HOMEOPATIA");
        this.setresenaactiva("HOMEOPATIA");
      }

      if (buttonindex == 7) {
        this.irpanel1("OLIGOELEMENTOS");
        this.setresenaactiva("OLIGOELEMENTOS");
      }

      if (buttonindex == 8) {
        this.irpanel1("ORTHOMOLECULAR");
        this.setresenaactiva("ORTHOMOLECULAR");
      }

      if (buttonindex == 9) {
        this.irpanelprobioticos("PROBIOTICOS/PREBIOTICOS");
        this.setresenaactiva("PROBIOTICOS");
      }

      if (buttonindex == 10) {
        this.irpanel1("PEPTONAS/HIDROLIZADOS");
        this.setresenaactiva("PEPTONASHIDROLIZADOS");
      }

      if (buttonindex == 11) {
        this.irpaneltinturas("TINTURAS MADRE");
        this.setresenaactiva("TINTURASMADRE");
      }

      if (buttonindex == 12) {
        this.irpanelvet("VETERINARIA");
        this.setresenaactiva("VETERINARIA");
      }

      if (buttonindex == 13) {
        this.irpanelbotiquin("BOTIQUINES Y KITS");
        this.setresenaactiva("BOTIQUINES");
      }

      if (buttonindex == 14) {
        this.irpanelnatyprop("PRODUCTOS NATURALES");
        this.setresenaactiva("NATURALES");
      }

      if (buttonindex == 15) {
        this.irpanelnatyprop("PRODUCTOS PROPIOS");
        this.setresenaactiva("PROPIOS");
      }

      if (buttonindex == 16) {
        this.irpanel1("HONGOS");
        this.setresenaactiva("HONGOS");
      }

      if (buttonindex == 17) {
        this.irpanel1("CANNABIS MEDICINAL");
        this.setresenaactiva("CANNABIS MEDICINAL");
      }

      if (buttonindex == 18) {
        this.irpanelesteriles("ESTERILES");
        this.setresenaactiva("ESTERILES");
      }

      if (buttonindex == 19) {
        this.irpanelhormonas("HORMONAS BIOIDENTICAS");
        this.setresenaactiva("HORMONAS BIOIDENTICAS");
      }
    },

    irpanel0: function () {
      // primero cambio titulo y filtro para buscar
      this.titulo = "INICIO";
      this.terapiabuscar = "";
      this.subterapiabuscar = "";
      this.filtrolibrebuscar = "";
      this.chip1 = false;
      this.chip2 = false;
      this.chip1texto = "";
      this.chip2texto = "";
      // seteo el panel visible
      this.panel0visible = true;
      this.panel1visible = false;
      this.panelhormonasvisible = false;
      this.panel1evisible = false;
      this.panel2visible = false;
      this.panelformulasvisible = false;
      this.panelsustanciasvisible = false;
      this.panelavanzadovisible = false;
      this.panelhomeovisible = false;
      this.panelfloralesvisible = false;
      this.paneltinturasvisible = false;
      this.panelbotiquinvisible = false;
      this.panelvetvisible = false;
      this.resultadosiniciovisibles = false;
      this.panelnatypropvisible = false;
      this.panelprobioticosvisible = false;
      this.panelesterilesvisible = false;
    },

    irpanelprobioticos: function (filtro) {
      this.titulo = filtro;
      this.terapiabuscar = filtro;
      this.subterapiabuscar = "";
      this.setchip1("");

      // seteo el panel visible
      this.panel0visible = false;
      this.panel1visible = false;
      this.panelhormonasvisible = false;
      this.panel1evisible = false;
      this.panel2visible = false;
      this.panelformulasvisible = false;
      this.panelsustanciasvisible = false;
      this.panelavanzadovisible = false;
      this.panelhomeovisible = false;
      this.panelfloralesvisible = false;
      this.paneltinturasvisible = false;
      this.panelbotiquinvisible = false;
      this.panelvetvisible = false;
      this.resultadosiniciovisibles = false;
      this.panelnatypropvisible = false;
      this.panelprobioticosvisible = true;
      this.panelesterilesvisible = false;
    },

    irpanelesteriles: function (filtro) {
      this.titulo = filtro;
      this.terapiabuscar = filtro;
      this.subterapiabuscar = "";
      this.setchip1("");

      // seteo el panel visible
      this.panel0visible = false;
      this.panel1visible = false;
      this.panelhormonasvisible = false;
      this.panel1evisible = false;
      this.panel2visible = false;
      this.panelformulasvisible = false;
      this.panelsustanciasvisible = false;
      this.panelavanzadovisible = false;
      this.panelhomeovisible = false;
      this.panelfloralesvisible = false;
      this.paneltinturasvisible = false;
      this.panelbotiquinvisible = false;
      this.panelvetvisible = false;
      this.resultadosiniciovisibles = false;
      this.panelnatypropvisible = false;
      this.panelprobioticosvisible = false;
      this.panelesterilesvisible = true;
    },

    irpanel1: function (filtro) {
      // primero cambio titulo y filtro para buscar
      this.titulo = filtro;
      this.terapiabuscar = filtro;
      this.subterapiabuscar = "";
      this.setchip1("");

      // seteo el panel visible
      this.panel0visible = false;
      this.panel1visible = true;
      this.panelhormonasvisible = false;
      this.panel1evisible = false;
      this.panel2visible = false;
      this.panelformulasvisible = false;
      this.panelsustanciasvisible = false;
      this.panelavanzadovisible = false;
      this.panelhomeovisible = false;
      this.panelfloralesvisible = false;
      this.paneltinturasvisible = false;
      this.panelbotiquinvisible = false;
      this.panelvetvisible = false;
      this.resultadosiniciovisibles = false;
      this.panelnatypropvisible = false;
      this.panelprobioticosvisible = false;
      this.panelesterilesvisible = false;

      //this.buscar();
    },

    irpanel1e: function (filtro) {
      // primero cambio titulo y filtro para buscar
      // solamente x formulas sin sustenacias, caso esteriles
      this.titulo = filtro;
      this.terapiabuscar = filtro;
      this.subterapiabuscar = "";
      this.setchip1("");

      // seteo el panel visible
      this.panel0visible = false;
      this.panel1visible = false;
      this.panelhormonasvisible = false;
      this.panel1evisible = true;
      this.panel2visible = false;
      this.panelformulasvisible = false;
      this.panelsustanciasvisible = false;
      this.panelavanzadovisible = false;
      this.panelhomeovisible = false;
      this.panelfloralesvisible = false;
      this.paneltinturasvisible = false;
      this.panelbotiquinvisible = false;
      this.panelvetvisible = false;
      this.resultadosiniciovisibles = false;
      this.panelnatypropvisible = false;
      this.panelprobioticosvisible = false;
      this.panelesterilesvisible = false;

      //this.buscar();
    },

    irpanel2: function (filtro) {
      // primero cambio titulo y filtro para buscar
      this.titulo = filtro;
      this.terapiabuscar = filtro;
      this.subterapiabuscar = "";
      this.setchip1("");

      // seteo el panel visible
      this.panel0visible = false;
      this.panel1visible = false;
      this.panelhormonasvisible = false;
      this.panel1evisible = false;
      this.panel2visible = true;
      this.panelformulasvisible = false;
      this.panelsustanciasvisible = false;
      this.panelavanzadovisible = false;
      this.panelhomeovisible = false;
      this.panelfloralesvisible = false;
      this.paneltinturasvisible = false;
      this.panelbotiquinvisible = false;
      this.panelvetvisible = false;
      this.resultadosiniciovisibles = false;
      this.panelnatypropvisible = false;
      this.panelprobioticosvisible = false;
      this.panelesterilesvisible = false;

    },

    irpanelavanzado: function () {
      // primero cambio titulo y filtro para buscar
      this.titulo = "Listado de sustancias";

      // seteo el panel visible
      this.panel0visible = false;
      this.panel1visible = false;
      this.panelhormonasvisible = false;
      this.panel1evisible = false;
      this.panel2visible = false;
      this.panelformulasvisible = false;
      this.panelsustanciasvisible = false;
      this.panelavanzadovisible = true;
      this.panelhomeovisible = false;
      this.panelfloralesvisible = false;
      this.paneltinturasvisible = false;
      this.panelbotiquinvisible = false;
      this.panelvetvisible = false;
      this.resultadosiniciovisibles = false;
      this.panelnatypropvisible = false;
      this.panelprobioticosvisible = false;
      this.panelesterilesvisible = false;

    },

    irpanelhomeo: function (filtro) {
      // primero cambio titulo y filtro para buscar
      this.titulo = filtro;
      this.terapiabuscar = filtro;
      this.subterapiabuscar = "";
      this.setchip1("");
      // seteo el panel visible
      this.panel0visible = false;
      this.panel1visible = false;
      this.panelhormonasvisible = false;
      this.panel1evisible = false;
      this.panel2visible = false;
      this.panelformulasvisible = false;
      this.panelsustanciasvisible = false;
      this.panelavanzadovisible = false;
      this.panelhomeovisible = true;
      this.panelfloralesvisible = false;
      this.paneltinturasvisible = false;
      this.panelbotiquinvisible = false;
      this.panelvetvisible = false;
      this.resultadosiniciovisibles = false;
      this.panelnatypropvisible = false;
      this.panelprobioticosvisible = false;
      this.panelesterilesvisible = false;

    },

    irpanelflorales: function (filtro) {
      // primero cambio titulo y filtro para buscar
      this.titulo = filtro;
      this.terapiabuscar = filtro;
      this.subterapiabuscar = "";
      this.setchip1("");

      // seteo el panel visible
      this.panel0visible = false;
      this.panel1visible = false;
      this.panelhormonasvisible = false;
      this.panel1evisible = false;
      this.panel2visible = false;
      this.panelformulasvisible = false;
      this.panelsustanciasvisible = false;
      this.panelavanzadovisible = false;
      this.panelhomeovisible = false;
      this.panelfloralesvisible = true;
      this.paneltinturasvisible = false;
      this.panelbotiquinvisible = false;
      this.panelvetvisible = false;
      this.resultadosiniciovisibles = false;
      this.panelnatypropvisible = false;
      this.panelprobioticosvisible = false;
      this.panelesterilesvisible = false;

    },

    irpaneltinturas: function (filtro) {
      // primero cambio titulo y filtro para buscar
      this.titulo = filtro;
      this.terapiabuscar = filtro;
      this.subterapiabuscar = "";
      this.setchip1("");

      // seteo el panel visible
      this.panel0visible = false;
      this.panel1visible = false;
      this.panelhormonasvisible = false;
      this.panel1evisible = false;
      this.panel2visible = false;
      this.panelformulasvisible = false;
      this.panelsustanciasvisible = false;
      this.panelavanzadovisible = false;
      this.panelhomeovisible = false;
      this.panelfloralesvisible = false;
      this.paneltinturasvisible = true;
      this.panelbotiquinvisible = false;
      this.panelvetvisible = false;
      this.resultadosiniciovisibles = false;
      this.panelnatypropvisible = false;
      this.panelprobioticosvisible = false;
      this.panelesterilesvisible = false;

    },

    irpanelbotiquin: function (filtro) {
      // primero cambio titulo y filtro para buscar
      this.titulo = filtro;
      this.terapiabuscar = filtro;
      this.subterapiabuscar = "";
      this.setchip1("");

      // seteo el panel visible
      this.panel0visible = false;
      this.panel1visible = false;
      this.panelhormonasvisible = false;
      this.panel1evisible = false;
      this.panel2visible = false;
      this.panelformulasvisible = false;
      this.panelsustanciasvisible = false;
      this.panelavanzadovisible = false;
      this.panelhomeovisible = false;
      this.panelfloralesvisible = false;
      this.paneltinturasvisible = false;
      this.panelbotiquinvisible = true;
      this.panelvetvisible = false;
      this.resultadosiniciovisibles = false;
      this.panelnatypropvisible = false;
      this.panelprobioticosvisible = false;
      this.panelesterilesvisible = false;

    },

    irpanelvet: function (filtro) {
      // primero cambio titulo y filtro para buscar
      this.titulo = filtro;
      this.terapiabuscar = filtro;
      this.subterapiabuscar = "";
      this.setchip1("");

      // seteo el panel visible
      this.panel0visible = false;
      this.panel1visible = false;
      this.panelhormonasvisible = false;
      this.panel1evisible = false;
      this.panel2visible = false;
      this.panelformulasvisible = false;
      this.panelsustanciasvisible = false;
      this.panelavanzadovisible = false;
      this.panelhomeovisible = false;
      this.panelfloralesvisible = false;
      this.paneltinturasvisible = false;
      this.panelbotiquinvisible = false;
      this.panelvetvisible = true;
      this.resultadosiniciovisibles = false;
      this.panelnatypropvisible = false;
      this.panelprobioticosvisible = false;
      this.panelesterilesvisible = false;

    },

    irpanelhormonas: function (filtro) {
      // primero cambio titulo y filtro para buscar
      this.titulo = filtro;
      this.terapiabuscar = filtro;
      this.subterapiabuscar = "";
      this.setchip1("");

      // seteo el panel visible
      this.panel0visible = false;
      this.panel1visible = false;
      this.panelhormonasvisible = true;
      this.panel1evisible = false;
      this.panel2visible = false;
      this.panelformulasvisible = false;
      this.panelsustanciasvisible = false;
      this.panelavanzadovisible = false;
      this.panelhomeovisible = false;
      this.panelfloralesvisible = false;
      this.paneltinturasvisible = false;
      this.panelbotiquinvisible = false;
      this.panelvetvisible = false;
      this.resultadosiniciovisibles = false;
      this.panelnatypropvisible = false;
      this.panelprobioticosvisible = false;
      this.panelesterilesvisible = false;
    },

    irpanelnatyprop: function (filtro) {
      // primero cambio titulo y filtro para buscar
      this.titulo = filtro;
      this.terapiabuscar = filtro;
      this.subterapiabuscar = "";
      this.setchip1("");

      // seteo el panel visible
      this.panel0visible = false;
      this.panel1visible = false;
      this.panelhormonasvisible = false;
      this.panel1evisible = false;
      this.panel2visible = false;
      this.panelformulasvisible = false;
      this.panelsustanciasvisible = false;
      this.panelavanzadovisible = false;
      this.panelhomeovisible = false;
      this.panelfloralesvisible = false;
      this.paneltinturasvisible = false;
      this.panelbotiquinvisible = false;
      this.panelvetvisible = false;
      this.resultadosiniciovisibles = false;
      this.panelnatypropvisible = true;
      this.panelprobioticosvisible = false;
      this.panelesterilesvisible = false;

    },

    chip1close: function () {
      this.chip1 = false;
      this.chip2 = false;
      this.chip1texto = "";
      this.chip2texto = "";
      this.terapiabuscar = "";
      this.subterapiabuscar = "";
      this.irpanel0();
    },

    chip2close: function () {
      this.chip2 = false;
      this.chip2texto = "";
      this.subterapiabuscar = "";

      this.panel0click(this.lastindexbutton);
    },

    chipLastclose: function () {
      if (this.lastChip == 1) {
        this.chip1close();
      } else {
        this.chip2close();
      }
    },

    buscar: function () {
      this.resultadoformula(this.subterapiabuscar);
    },

    resultadoformula: function (subterapia) {
      this.subterapiabuscar = subterapia;
      this.setchip2("FORMULAS");
      this.titulo = this.terapiabuscar + " > " + subterapia + " > FORMULAS";
      this.panel0visible = false;
      this.panel1visible = false;
      this.panelhormonasvisible = false;
      this.panel1evisible = false;
      this.panel2visible = false;
      this.panelformulasvisible = true;
      this.panelsustanciasvisible = false;
      this.panelavanzadovisible = false;
      this.panelhomeovisible = false;
      this.panelfloralesvisible = false;
      this.paneltinturasvisible = false;
      this.panelbotiquinvisible = false;
      this.panelvetvisible = false;
      this.resultadosiniciovisibles = false;
      this.panelnatypropvisible = false;
      this.panelprobioticosvisible = false;
      this.panelesterilesvisible = false;


      let me = this;
      me.resultados = [];
      axios
        .post("api/Formulas/Buscar", {
          terapia: this.terapiabuscar.trim(),
          subterapia: this.subterapiabuscar.trim(),
          filtrolibre: this.filtrolibrebuscar.trim(),
        })
        .then(function (response) {
          me.resultados = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    setchip2: function (texto) {
      if (this.subterapiabuscar == "") {
        this.chip2texto = texto;
      } else {
        this.chip2texto = this.subterapiabuscar;
      }

      this.chip2 = true;
      this.lastChip = 2;
    },

    setchip1: function (texto) {
      if (this.terapiabuscar == "") {
        this.chip1texto = texto;
      } else {
        this.chip1texto = this.terapiabuscar;
      }

      this.chip1 = true;
      this.lastChip = 1;
    },

    resultadosustancia: function (subterapia) {
      this.subterapiabuscar = subterapia;
      this.setchip2("SUSTANCIAS");
      this.titulo = this.terapiabuscar + " > " + subterapia + " > SUSTANCIAS";

      this.panel0visible = false;
      this.panel1visible = false;
      this.panelhormonasvisible = false;
      this.panel1evisible = false;
      this.panel2visible = false;
      this.panelformulasvisible = false;
      this.panelsustanciasvisible = true;
      this.panelavanzadovisible = false;
      this.panelhomeovisible = false;
      this.panelfloralesvisible = false;
      this.paneltinturasvisible = false;
      this.panelbotiquinvisible = false;
      this.panelvetvisible = false;
      this.resultadosiniciovisibles = false;
      this.panelnatypropvisible = false;
      this.panelprobioticosvisible = false;
      this.panelesterilesvisible = false;


      let me = this;
      me.sustanciaresultados = [];
      axios
        .post("api/Sustancias/BuscarConTerapia", {
          terapia: this.terapiabuscar.trim(),
          subterapia: this.subterapiabuscar.trim(),
          filtrolibre: this.filtrolibrebuscar.trim(),
        })
        .then(function (response) {
          me.sustanciaresultados = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    setresenaactiva: function (texto) {
      this.resenaaceitesescenciales = texto == "AROMATERAPIA";
      this.resenaayurvedico = texto == "AYURVEDA";
      this.resenahongos = texto == "HONGOS";
      this.resenacannabis = texto == "CANNABIS MEDICINAL";
      this.resenaesteriles = texto == "ESTERILES";
      this.resenabotiquines = texto == "BOTIQUINES";
      this.resenaextractos = texto == "EXTRACTOS";
      this.resenafitoterapia = texto == "FITOTERAPIA";
      this.resenaflorales = texto == "FLORALES";
      this.resenahomeopatia = texto == "HOMEOPATIA";
      this.resenanaturales = texto == "NATURALES";
      this.resenaoligoelementos = texto == "OLIGOELEMENTOS";
      this.resenaorthomolecular = texto == "ORTHOMOLECULAR";
      this.resenapeptonashidrolizados = texto == "PEPTONASHIDROLIZADOS";
      this.resenaprobioticos = texto == "PROBIOTICOS";
      this.resenapropios = texto == "PROPIOS";
      this.resenatinturasmadre = texto == "TINTURASMADRE";
      this.resenaveterinaria = texto == "VETERINARIA";
    },

    //prueba de funciones para corregir indice de dirección
    resultadosustanciasst: function (subterapia) {
      this.subterapiabuscar = subterapia;
      this.setchip2("SUSTANCIAS");
      this.titulo = this.terapiabuscar + " > SUSTANCIAS";
      this.panel0visible = false;
      this.panel1visible = false;
      this.panelhormonasvisible = false;
      this.panel1evisible = false;
      this.panel2visible = false;
      this.panelformulasvisible = false;
      this.panelsustanciasvisible = true;
      this.panelavanzadovisible = false;
      this.panelhomeovisible = false;
      this.panelfloralesvisible = false;
      this.paneltinturasvisible = false;
      this.panelbotiquinvisible = false;
      this.panelvetvisible = false;
      this.resultadosiniciovisibles = false;
      this.panelnatypropvisible = false;
      this.panelprobioticosvisible = false;
      this.panelesterilesvisible = false;

      let me = this;
      me.sustanciaresultados = [];
      axios
        .post("api/Sustancias/BuscarConTerapia", {
          terapia: this.terapiabuscar.trim(),
          subterapia: this.subterapiabuscar.trim(),
          filtrolibre: this.filtrolibrebuscar.trim(),
        })
        .then(function (response) {
          me.sustanciaresultados = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    resultadoformulasst: function (subterapia) {
      this.subterapiabuscar = subterapia;
      this.setchip2("FORMULAS");
      this.titulo = this.terapiabuscar + " > FORMULAS";
      this.panel0visible = false;
      this.panel1evisible = false;
      this.panel1visible = false;
      this.panelhormonasvisible = false;
      this.panel1evisible = false;
      this.panel2visible = false;
      this.panelformulasvisible = true;
      this.panelsustanciasvisible = false;
      this.panelavanzadovisible = false;
      this.panelhomeovisible = false;
      this.panelfloralesvisible = false;
      this.paneltinturasvisible = false;
      this.panelbotiquinvisible = false;
      this.panelvetvisible = false;
      this.resultadosiniciovisibles = false;
      this.panelnatypropvisible = false;
      this.panelprobioticosvisible = false;
      this.panelesterilesvisible = false;


      let me = this;
      me.resultados = [];
      axios
        .post("api/Formulas/Buscar", {
          terapia: this.terapiabuscar.trim(),
          subterapia: this.subterapiabuscar.trim(),
          filtrolibre: this.filtrolibrebuscar.trim(),
        })
        .then(function (response) {
          me.resultados = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    //fin de funciones de prueba
  },
};
</script>

<style>
.theme--light.v-data-table tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, 0.03);
}
.theme--dark.v-data-table tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, 0.5);
}
</style>
